import { AdMob, BannerAdOptions, BannerAdSize, BannerAdPosition } from '@capacitor-community/admob';

// AdMob configuration
const ADMOB_CONFIG = {
  android: {
    bannerId: 'ca-app-pub-8076385002734863/1902949692',
  },
  ios: {
    bannerId: 'ca-app-pub-8076385002734863/4249182489',
  },
};

// Detect platform
const isAndroid = () => {
  return /android/i.test(navigator.userAgent);
};

const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

const isNativeApp = () => {
  return window.Capacitor !== undefined && window.Capacitor.isNativePlatform();
};

// Get the correct banner ID based on platform
const getBannerId = () => {
  if (isAndroid()) {
    return ADMOB_CONFIG.android.bannerId;
  } else if (isIOS()) {
    return ADMOB_CONFIG.ios.bannerId;
  }
  // Fallback for testing in browser
  return ADMOB_CONFIG.android.bannerId;
};

// Initialize AdMob
export const initializeAdMob = async () => {
  if (!isNativeApp()) {
    console.log('AdMob: Not running in native app, skipping initialization');
    return false;
  }

  try {
    await AdMob.initialize({
      requestTrackingAuthorization: true,
      initializeForTesting: false, // Set to true for testing with test ads
    });
    console.log('AdMob initialized successfully');
    return true;
  } catch (error) {
    console.error('AdMob initialization error:', error);
    return false;
  }
};

// Show banner ad at bottom of screen
export const showBannerAd = async () => {
  if (!isNativeApp()) {
    console.log('AdMob: Not running in native app, skipping banner');
    return false;
  }

  try {
    const options = {
      adId: getBannerId(),
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position: BannerAdPosition.BOTTOM_CENTER,
      margin: 0,
      isTesting: false, // Set to true to show test ads
    };

    await AdMob.showBanner(options);
    console.log('Banner ad shown successfully');
    return true;
  } catch (error) {
    console.error('Show banner error:', error);
    return false;
  }
};

// Hide banner ad
export const hideBannerAd = async () => {
  if (!isNativeApp()) {
    return false;
  }

  try {
    await AdMob.hideBanner();
    console.log('Banner ad hidden');
    return true;
  } catch (error) {
    console.error('Hide banner error:', error);
    return false;
  }
};

// Remove banner ad completely
export const removeBannerAd = async () => {
  if (!isNativeApp()) {
    return false;
  }

  try {
    await AdMob.removeBanner();
    console.log('Banner ad removed');
    return true;
  } catch (error) {
    console.error('Remove banner error:', error);
    return false;
  }
};

// Resume banner ad (after hiding)
export const resumeBannerAd = async () => {
  if (!isNativeApp()) {
    return false;
  }

  try {
    await AdMob.resumeBanner();
    console.log('Banner ad resumed');
    return true;
  } catch (error) {
    console.error('Resume banner error:', error);
    return false;
  }
};

export default {
  initializeAdMob,
  showBannerAd,
  hideBannerAd,
  removeBannerAd,
  resumeBannerAd,
  isNativeApp,
};
